var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOlives(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 381.6 381.6",
    style: {
      enableBackground: "new 0 0 381.6 381.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{opacity:0.3;fill:url(#SVGID_2_);}\n\t.st2{opacity:0.3;fill:url(#SVGID_3_);}\n\t.st3{opacity:0.3;fill:url(#SVGID_4_);}\n\t.st4{fill:#144344;}\n\t.st5{fill:#569B9B;}\n\t.st6{fill:url(#SVGID_5_);}\n\t.st7{opacity:0.3;fill:url(#SVGID_6_);}\n\t.st8{opacity:0.3;fill:url(#SVGID_7_);}\n\t.st9{opacity:0.3;fill:url(#SVGID_8_);}\n\t.st10{opacity:0.3;fill:url(#SVGID_9_);}\n\t.st11{opacity:0.3;fill:url(#SVGID_10_);}\n\t.st12{opacity:0.3;fill:url(#SVGID_11_);}\n\t.st13{fill:url(#SVGID_12_);}\n\t.st14{opacity:0.3;fill:url(#SVGID_13_);}\n\t.st15{opacity:0.3;fill:url(#SVGID_14_);}\n\t.st16{opacity:0.3;fill:url(#SVGID_15_);}\n\t.st17{opacity:0.3;fill:url(#SVGID_16_);}\n\t.st18{opacity:0.3;fill:url(#SVGID_17_);}\n\t.st19{opacity:0.3;fill:url(#SVGID_18_);}\n\t.st20{fill:url(#SVGID_19_);}\n\t.st21{opacity:0.3;fill:url(#SVGID_20_);}\n\t.st22{opacity:0.3;fill:url(#SVGID_21_);}\n\t.st23{opacity:0.3;fill:url(#SVGID_22_);}\n\t.st24{opacity:0.3;fill:url(#SVGID_23_);}\n\t.st25{opacity:0.3;fill:url(#SVGID_24_);}\n\t.st26{opacity:0.3;fill:url(#SVGID_25_);}\n\t.st27{fill:url(#SVGID_26_);}\n\t.st28{opacity:0.3;fill:url(#SVGID_27_);}\n\t.st29{opacity:0.3;fill:url(#SVGID_28_);}\n\t.st30{opacity:0.3;fill:url(#SVGID_29_);}\n\t.st31{fill:url(#SVGID_30_);}\n\t.st32{opacity:0.3;fill:url(#SVGID_31_);}\n\t.st33{opacity:0.3;fill:url(#SVGID_32_);}\n\t.st34{opacity:0.3;fill:url(#SVGID_33_);}\n\t.st35{fill:url(#SVGID_34_);}\n\t.st36{opacity:0.3;fill:url(#SVGID_35_);}\n\t.st37{opacity:0.3;fill:url(#SVGID_36_);}\n\t.st38{fill:url(#SVGID_37_);}\n\t.st39{opacity:0.3;fill:url(#SVGID_38_);}\n\t.st40{opacity:0.3;fill:url(#SVGID_39_);}\n\t.st41{fill:url(#SVGID_40_);}\n\t.st42{opacity:0.3;fill:url(#SVGID_41_);}\n\t.st43{opacity:0.3;fill:url(#SVGID_42_);}\n\t.st44{fill:url(#SVGID_43_);}\n\t.st45{opacity:0.3;fill:url(#SVGID_44_);}\n\t.st46{opacity:0.3;fill:url(#SVGID_45_);}\n\t.st47{opacity:0.3;fill:url(#SVGID_46_);}\n\t.st48{opacity:0.3;fill:url(#SVGID_47_);}\n\t.st49{opacity:0.3;fill:url(#SVGID_48_);}\n\t.st50{opacity:0.3;fill:url(#SVGID_49_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "olives"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M288.3,261.4c0,0-0.2,4.1,0.3,5.5c1.2,3.8,5.5,7.6,12.8,9c7.6,1.6,11.8-1,14.8-6.2c3.2-5.4,2.1-11,2.1-11 s-6.8,14.6-14,12.2C297.2,268.5,288.3,261.4,288.3,261.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M295.7,262.2c0,0,4.1-5.6,8.2-6.1c4.6-0.5,5.5,1.7,6.6,4.5s3.3-4.3,1.7-5.8c-1.6-1.5-3.7-3-7-2.7c-3.2,0.3-7.1,1-8.7,3.6 C294.8,258.3,295.7,262.2,295.7,262.2z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 297.7445,
    cy: 260.0528,
    r: 16.0532,
    gradientTransform: "matrix(-1 0 0 1 601.14 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    style: {
      stopColor: "#000000"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M288.6,259.8c1-4.1,2.7-6.1,6-9.3c5-4.8,12-7.4,17.8-2.4c9.2,7.9,5.5,15.6,2.6,20.3c-1.9,3.1-5.1,6-8.9,6 c-4.4,0-9.7-1.7-13.2-4.5C289.8,267.4,287.6,263.7,288.6,259.8z M301.1,264.7c3.5,1.2,6.5,1.7,8.2-2.4c0.9-2,2-5.2-0.7-7.5 c-3-2.6-9.8-0.2-12.2,4C295.8,259.8,296.2,263,301.1,264.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.561,
    y1: 389.9959,
    x2: 236.561,
    y2: 372.8192,
    gradientTransform: "matrix(-0.862 -0.507 -0.507 0.862 708.5364 56.8842)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M317.3,260.6c0.4-1.9-1.4-2.1-3.9-1.8c-3.7,0.5-2.7,3.6-4.8,5.9c-0.9,1-2.4,1.3-2.8,2.7 c-0.3,1,0.2,2.6,0.2,4c0,2.3,2.2,2.2,4.6,0.6C313.1,270.2,316.1,267,317.3,260.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.5574,
    y1: 390.3171,
    x2: 255.5574,
    y2: 380.0743,
    gradientTransform: "matrix(-0.862 -0.507 -0.507 0.862 708.5364 56.8842)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M296.3,257.4c0.6-1.2,0-2.2-1.3-2.7c-3.2-1.3-4.7,2.1-5,4.9c-0.1,1.3-0.5,3.4,0.6,4.3c1,0.9,2.9-0.2,3.7-0.8 C296.1,261.8,294.8,260.4,296.3,257.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -35.3771,
    y1: 362.2565,
    x2: -35.3771,
    y2: 352.5885,
    gradientTransform: "matrix(-0.2029 -0.9792 -0.9792 0.2029 644.6536 142.8549)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M305.1,251.7c1.2-0.4,2-1.6,1.4-2.9c-1.1-2.4-4.1-2.2-6.4-0.5c-1,0.8-2.8,1.9-2.8,3.3c0,1.4,1.9,1.7,2.8,1.5 C302.2,252.8,304.1,252,305.1,251.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M310.2,248.6c0-0.1-0.1-0.1-0.1-0.1c-0.3,0.2-0.4,0.5-0.2,0.8c0,0.1,0.2,0.1,0.2,0 C310.2,249.1,310.3,248.8,310.2,248.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M310.8,270.3c0.1,0,0.1,0,0.1-0.1c0-0.3-0.1-0.6-0.4-0.7c-0.1,0-0.2,0.1-0.2,0.2 C310.4,270,310.6,270.2,310.8,270.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M294.5,262.1c-0.3,0.1-2.6,0.7-3.5,1c-0.3,0.1-0.5,0.3-0.2,0.3c0.9,0,2.7-0.5,3.7-1.1 C294.7,262.2,295,261.9,294.5,262.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M295.4,252.9c-0.3-0.3-0.5-0.6-0.7-0.7c-0.1-0.1-0.3,0-0.2,0.2c0.1,0.3,0.5,0.6,0.8,0.8 C295.5,253.2,295.6,253,295.4,252.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M315.7,256.9c-0.5,0.1-0.8,0.1-1,0.2c-0.2,0-0.2,0.2,0.1,0.3c0.3,0.1,0.8-0.1,1.1-0.2 C316.1,257,315.9,256.9,315.7,256.9z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M309.1,262.4c-0.6,1.5-1.6,2-1.9,2.1c-2.5,1.6-5.3,0.2-6.6-0.3c-0.8-0.4-2.1-1.2-2.9-2 c-0.9-1-1.3-1.7-1.1-2.7c0.2-1.5,1.6-3,2.8-3.9c-0.9,0.4-1.6,1.1-2.2,1.8c-1,1.1-1.8,2.7-0.1,4.8c1.9,2.3,4.6,3.4,7.5,3.7 c1.5,0.2,2.9-0.5,3.8-1.5c1-1.2,1.5-3.3,1.9-4.8C309.9,260.3,309.6,261.2,309.1,262.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M293.4,264.7c-0.5,0.4-1.1,1-1.6,1.5c-0.5,0.5-0.1,0.6,0.5,0.3c0.6-0.3,2.2-1.9,2.4-2.3 C294.8,263.9,294.3,264.1,293.4,264.7z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M318.1,261c-1.2,4-3,8.2-6,10.7c-3,2.5-7.1,3-10.8,1.9c-3.9-1.1-8.8-3-10.9-6.6c-2.1-3.5-1.7-7.8-0.2-11.2 c-1.6,3-2.5,5.9-1.4,9.3c1.7,5.2,8.1,7.8,12.3,9.1c2.6,0.7,6.8,1.4,10.6-1.4C315.4,269.9,317.5,265.4,318.1,261z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M295.1,263.5c-0.1,0.1,0.1,0.3,0.2,0.2c0.1-0.1,0.3-0.1,0.4-0.3C295.8,263.2,295.6,263.1,295.1,263.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M311.9,266.5c0.6,0.4,1.3,0.7,1.9,1c0.6,0.3,0.6-0.1,0.1-0.5c-0.5-0.4-2.5-1.3-3-1.4 C310.6,265.5,310.9,265.9,311.9,266.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M310.1,265.4c0.1,0.1,0.2-0.2,0.1-0.3c-0.1-0.1-0.2-0.2-0.4-0.2C309.6,264.9,309.6,265.1,310.1,265.4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M302.1,270.1c-0.2,0.6-0.2,1.5-0.3,2.1c-0.1,0.6,0.3,0.5,0.5-0.1c0.2-0.6,0.5-2.8,0.4-3.3 C302.6,268.5,302.4,269,302.1,270.1z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M302.7,268.1c0,0.2,0.2,0.2,0.3,0c0.1-0.1,0.1-0.3,0.1-0.5C303,267.5,302.8,267.5,302.7,268.1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M310.8,251.9c0.4-0.5,0.8-1.2,1.2-1.8c0.3-0.6-0.1-0.6-0.5-0.1c-0.5,0.4-1.6,2.4-1.7,2.8 C309.6,253.1,310.1,252.8,310.8,251.9z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M309.4,253.4c0.1-0.1-0.2-0.2-0.3-0.1c-0.1,0.1-0.2,0.2-0.2,0.4C308.9,253.9,309.1,254,309.4,253.4z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M294.5,260.4c-0.4-0.2-0.7-0.3-1.2-0.3c-0.4,0-1.8,0.1-2.3,0.4c-0.1,0.1-0.3,0.2,0,0.2 c0.6-0.1,1.3-0.1,1.9-0.1c0.5,0,1,0,1.5,0C294.7,260.6,294.6,260.4,294.5,260.4z"
  }))), /*#__PURE__*/React.createElement("g", null, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M218.6,64.7c0,0,3.1,3.4,4.2,4c2.4,1.3,8.9,2.9,12.8,0.3c3.8-2.5,6.4-6.1,7.5-11.1c1.7-7.5,0.5-9.9-0.9-12.8 c-0.5-1.2-3.3-4-3.3-4s0,11.5-2.8,15.7C233.4,60.9,218.6,64.7,218.6,64.7z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M234.8,48.7c0,0-1.9-1.2-4.4,0c-2.5,1.2-5,4.7-5.6,6.3c-0.8,2.3-0.3,7.4-0.3,7.4s-9.4-6.8-2.1-13.1 C229.8,42.8,233.6,46,234.8,48.7z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 228.222,
    cy: 53.9748,
    r: 15.7737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    style: {
      stopColor: "#000000"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M234.7,39c-6.8-1.6-12.2,4-18.5,11c-5.3,5.9,2.1,18.2,11,18.8c8.9,0.6,12.8-5.3,14.4-13.2 C242.8,49.2,242.8,40.9,234.7,39z M229.8,60.3c-3.5,0.7-9.7-2.8-6.7-7c2.1-3.1,5.9-7.7,9.1-6.1C237.7,49.9,233.3,59.6,229.8,60.3 z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M239.4,41.5c4.6,8.2,2.1,15.3-1.8,21.8c-2.4,4-6.3,4.6-10.6,4.3c-4.7-0.3-7.1-1.8-10.6-6.1 c1.9,3.6,4.8,6.2,9.4,6.7c4.3,0.5,8.8,0.3,11.6-3.4C242.1,58.7,245.7,47.5,239.4,41.5z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M232.9,47.6c2,1.8,1.8,7.9-0.7,10.6c-3.2,3.4-9,1.8-10-2.2c0.1,4.5,6.4,6.3,9.7,3.2 C234.7,56.7,236.4,50.1,232.9,47.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.3318,
    y1: 44.9349,
    x2: 226.0984,
    y2: 42.1927
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M235.9,41.1c-2-1.2-4.6-1-6.8,0c-1.2,0.6-4.1,2.3-3.4,3.8c0.6,1.3,3.3,0.1,4.8,0c2.6-0.2,3.2,1,5,2.3 c1.5,1.1,3.5,0.9,3.6-1.3C239.2,43.9,237.5,42,235.9,41.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.9391,
    y1: 62.8869,
    x2: 229.0287,
    y2: 61.455
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M234.9,59.2c-1.4,0.6-1.6,2-3.7,2.9c-0.5,0.2-2.5,0.8-2.6,1.8c-0.1,1,1,1.3,1.7,1.4c1.4,0.2,3.2-0.1,4.3-0.9 c0.9-0.7,2-2.5,1.9-3.8C236.3,59.7,235.7,58.8,234.9,59.2z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M236.5,43.3c-0.2-0.3-0.8-1.1-1.2-1c-0.4,0.1,0.1,0.4,0.2,0.5c1.1,1.1,0.9,1.8,1.3,2.3 c0.1,0.1,0.3,0.1,0.4,0C237.2,44.4,236.8,43.7,236.5,43.3z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M234.4,41.7c-0.2-0.2-0.4-0.2-0.6-0.2c-0.1,0-0.2,0.2,0,0.3c0.2,0.1,0.3,0.1,0.5,0.2 C234.3,42.1,234.5,41.9,234.4,41.7z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M224.9,61.3c-0.5,0.5-2.2,1.8-3.6,2.3c-0.4,0.2-0.3,0.4,0.2,0.3c1.5-0.5,3.2-1.8,3.6-2.4 C225.3,61.2,225.3,60.9,224.9,61.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.8928,
    y1: 53.591,
    x2: 221.8299,
    y2: 53.591
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M221.5,53.3c-0.7,0.2-2.8,0.3-4.3,0.1c-0.4-0.1-0.5,0.2,0,0.3c1.5,0.4,3.7,0.1,4.3-0.2 C221.9,53.4,222,53.2,221.5,53.3z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M223.7,60.5c-0.2,0.1-0.4,0.2-0.6,0.3c-0.2,0.2-0.1,0.3,0.1,0.2c0.2-0.1,0.4-0.2,0.6-0.4 C224,60.5,223.9,60.4,223.7,60.5z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M215.9,52.9c0.2-1.1,1-2.5,2.2-3.2c0.2-0.1,0.3-0.5,0-0.3c-2.2,1.2-3.9,5.3-1.7,7.2c0.3,0.2,0.5,0.2,0.3-0.2 C216.3,55.2,215.6,54.3,215.9,52.9z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M222.8,48.5c-0.2-0.1-0.3-0.1-0.5-0.2c-0.2,0-0.3,0.2-0.1,0.3c0.2,0.1,0.3,0.2,0.5,0.2 C222.9,49,223,48.7,222.8,48.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.592,
    y1: 52.1769,
    x2: 218.4197,
    y2: 52.1769
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M218.3,52.1c-0.2-0.1-0.3-0.1-0.5-0.2c-0.2,0-0.3,0.2-0.1,0.3c0.2,0.1,0.3,0.2,0.5,0.2 C218.4,52.5,218.5,52.2,218.3,52.1z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M223.5,47c-0.1-0.3-0.3-0.5-0.5-0.7c-0.3-0.3-0.6-0.1-0.3,0.3c0.1,0.2,0.3,0.4,0.6,0.5 C223.4,47.2,223.6,47.1,223.5,47z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 163.2453,
    y1: 151.8491,
    x2: 164.1376,
    y2: 151.8491,
    gradientTransform: "matrix(0.7297 -0.6838 0.6838 0.7297 14.7119 57.5996)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M238.5,56.4c-0.3-0.1-0.5-0.2-0.8-0.2c-0.4,0-0.5,0.3,0,0.4c0.3,0.1,0.5,0.1,0.8,0 C238.6,56.6,238.6,56.5,238.5,56.4z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M239.9,52.5c-1.1,0-2.8,0.1-3.8,0.3c-0.3,0-0.2,0.3,0.1,0.3c0.6,0,3.1-0.2,3.7-0.3 C240.2,52.7,240.3,52.5,239.9,52.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.9353,
    y1: 49.6056,
    x2: 240.1973,
    y2: 49.6056
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M239.8,48.7c-0.8,0.7-2.7,1.3-3.7,1.6c-0.3,0.1-0.2,0.3,0.1,0.3c0.7-0.1,2.4-0.6,3.7-1.4 C240.3,48.9,240.3,48.4,239.8,48.7z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M238.5,54.2c-0.4-0.3-1.2-0.5-1.7-0.3c-0.2,0-0.3,0.2,0.1,0.3c0.4,0.1,1.1,0,1.5,0.2 C238.6,54.5,238.6,54.3,238.5,54.2z"
  }))), /*#__PURE__*/React.createElement("g", null, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4,100.1c0,0,1.6,4.3,1.6,5.6c0,2.8-1.5,9.2-5.6,11.5c-3.9,2.2-8.4,2.8-13.3,1.5c-7.4-1.9-9-4.1-10.9-6.6 c-0.8-1-2.1-4.8-2.1-4.8s10.2,5.4,15.2,4.8S98.4,100.1,98.4,100.1z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7,107.1c0,0-0.2-2.3,2-3.9c2.2-1.6,6.5-2.3,8.2-2.1c2.4,0.3,6.7,3.1,6.7,3.1s-1.7-11.5-10.7-7.9 C73.9,100,75,104.8,76.7,107.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_12_",
    cx: 90.0619,
    cy: 104.7278,
    r: 15.7738,
    gradientTransform: "matrix(0.4604 -0.8877 0.8877 0.4604 -50.0062 135.5536)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    style: {
      stopColor: "#000000"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M68.2,102.6c1.7-6.7,9.2-9,18.3-11.4c7.7-2,15.2,10.2,11.6,18.4c-3.6,8.1-10.6,8.9-18.4,6.7 C73.5,114.4,66.2,110.6,68.2,102.6z M89.4,108c2.2-2.8,2-9.9-3.1-9.2c-3.7,0.5-9.6,1.7-9.6,5.2C76.5,110.3,87.2,110.8,89.4,108z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M68.3,107.9c5.2,7.8,12.6,8.9,20.2,8.4c4.7-0.3,6.9-3.4,8.7-7.4c1.9-4.3,1.7-7.1-0.5-12.2 c2.3,3.3,3.3,7.1,1.6,11.4c-1.5,4-3.8,7.9-8.4,8.8C82.3,118.2,70.7,116.3,68.3,107.9z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M76.7,104.9c0.7,2.6,6.2,5.2,9.7,4.3c4.5-1.2,5.7-7.1,2.6-9.9c4,2.2,2.7,8.6-1.6,10.1 C83.9,110.7,77.3,109.2,76.7,104.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.4561,
    y1: 96.6673,
    x2: 79.7493,
    y2: 94.0342,
    gradientTransform: "matrix(0.4604 -0.8877 0.8877 0.4604 -50.0062 135.5536)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M69.5,104.6c-0.1-2.4,1.2-4.6,3.1-6c1.1-0.8,3.9-2.6,4.9-1.2c0.8,1.1-1.4,3-2.2,4.2 c-1.3,2.2-0.6,3.3-0.3,5.5c0.3,1.9-0.8,3.5-2.8,2.6C70.5,108.8,69.6,106.5,69.5,104.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 90.0641,
    y1: 114.0874,
    x2: 81.8515,
    y2: 112.3856,
    gradientTransform: "matrix(0.4604 -0.8877 0.8877 0.4604 -50.0062 135.5536)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M86.1,112c1.2-0.9,2.5-0.5,4.3-2c0.4-0.4,1.9-1.9,2.8-1.5c0.9,0.4,0.7,1.5,0.5,2.1 c-0.4,1.3-1.5,2.8-2.8,3.4c-1.1,0.5-3.2,0.6-4.3-0.1C85.9,113.5,85.4,112.6,86.1,112z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M71.2,106.1c-0.2-0.3-0.6-1.2-0.3-1.5c0.2-0.3,0.3,0.3,0.3,0.4c0.5,1.5,1.2,1.7,1.5,2.2 c0.1,0.1,0,0.4-0.2,0.3C71.9,107.3,71.4,106.6,71.2,106.1z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M70.8,103.5c-0.1-0.3-0.1-0.4,0.1-0.6c0.1-0.1,0.3,0,0.3,0.1c0,0.2,0,0.3-0.1,0.5 C71.1,103.7,70.8,103.7,70.8,103.5z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M92.5,104.1c0.7-0.2,2.6-1.1,3.7-2.1c0.3-0.3,0.5-0.1,0.2,0.3c-1.1,1.1-3.1,2-3.8,2.1 C92.2,104.4,92,104.3,92.5,104.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.9121,
    y1: 104.9392,
    x2: 75.8493,
    y2: 104.9392,
    gradientTransform: "matrix(-0.4604 0.8877 0.8877 0.4604 28.8513 -17.7857)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M87,97.4c0.5-0.5,1.6-2.3,2.1-3.7c0.1-0.4,0.4-0.3,0.3,0.1c-0.4,1.5-1.6,3.4-2.1,3.8 C86.9,97.8,86.6,97.8,87,97.4z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M92.3,102.7c0.2-0.2,0.4-0.3,0.6-0.4c0.2-0.1,0.3,0,0.1,0.2c-0.2,0.2-0.4,0.3-0.6,0.4 C92.2,103,92.2,102.9,92.3,102.7z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M89.2,92.3c-1-0.3-2.7-0.2-3.8,0.5c-0.2,0.1-0.6,0.1-0.3-0.1c2.1-1.4,6.5-1,7.2,1.8c0.1,0.3,0,0.5-0.3,0.2 C91,93.7,90.6,92.7,89.2,92.3z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M82.1,96.4c0-0.2,0-0.3,0.1-0.5c0.1-0.2,0.3-0.2,0.4,0c0,0.2,0,0.3,0,0.5C82.5,96.7,82.2,96.6,82.1,96.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 71.6114,
    y1: 103.525,
    x2: 72.439,
    y2: 103.525,
    gradientTransform: "matrix(-0.4604 0.8877 0.8877 0.4604 28.8513 -17.7857)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M87.3,94c0-0.2,0-0.3,0.1-0.5c0.1-0.2,0.3-0.2,0.4,0c0,0.2,0,0.3,0,0.5C87.7,94.3,87.4,94.3,87.3,94z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M80.4,96.3c-0.2-0.2-0.3-0.4-0.4-0.7c-0.1-0.4,0.2-0.6,0.4-0.1c0.1,0.2,0.2,0.5,0.2,0.8 C80.7,96.3,80.5,96.4,80.4,96.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.7986,
    y1: 89.3746,
    x2: 23.6911,
    y2: 89.3746,
    gradientTransform: "matrix(-0.9429 0.333 0.333 0.9429 74.3574 21.5215)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M81.9,114c0-0.3,0.1-0.5,0.2-0.8c0.2-0.3,0.5-0.3,0.4,0.2c-0.1,0.3-0.2,0.5-0.4,0.7 C82.1,114.1,81.9,114.1,81.9,114z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M77.8,113.4c0.5-1,1.4-2.4,2-3.3c0.2-0.2,0.4-0.1,0.2,0.2c-0.3,0.5-1.6,2.7-1.9,3.1 C77.9,113.8,77.6,113.8,77.8,113.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.9549,
    y1: 100.9545,
    x2: 94.217,
    y2: 100.9545,
    gradientTransform: "matrix(-0.4604 0.8877 0.8877 0.4604 28.8513 -17.7857)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M74.5,111.6c1-0.4,2.4-1.8,3.1-2.6c0.2-0.2,0.3,0,0.2,0.2c-0.4,0.6-1.7,1.8-2.9,2.6 C74.5,112.1,73.9,111.9,74.5,111.6z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M80,112.9c-0.1-0.5,0.1-1.3,0.5-1.7c0.1-0.1,0.4-0.1,0.2,0.2c-0.1,0.4-0.5,1-0.5,1.4 C80.1,113.2,80,113,80,112.9z"
  }))), /*#__PURE__*/React.createElement("g", null, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M254.2,294.1c0,0-1.7,4.2-1.8,5.5c-0.1,2.8,1.2,9.3,5.2,11.7c3.9,2.3,8.3,3.1,13.3,2c7.5-1.7,9.1-3.8,11.1-6.3 c0.8-1,2.2-4.7,2.2-4.7s-10.4,5-15.3,4.3C263.9,305.7,254.2,294.1,254.2,294.1z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M275.6,301.7c0,0,0.3-2.3-1.9-4s-6.4-2.5-8.1-2.3c-2.5,0.3-6.8,2.9-6.8,2.9s2.1-11.4,10.9-7.5S277.4,299.5,275.6,301.7z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_19_",
    cx: 281.0196,
    cy: 297.4834,
    r: 15.7731,
    gradientTransform: "matrix(0.4316 0.9021 -0.9021 0.4316 415.0257 -83.8247)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    style: {
      stopColor: "#000000"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M284.2,297.5c-1.5-6.8-8.9-9.3-17.9-11.9c-7.6-2.2-15.5,9.7-12.2,18c3.3,8.2,10.3,9.2,18.1,7.3 C278.6,309.2,286,305.6,284.2,297.5z M262.9,302.2c-2.1-2.9-1.7-9.9,3.4-9.1c3.7,0.6,9.5,2,9.4,5.5 C275.7,304.9,265,305.1,262.9,302.2z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M284,302.8c-5.4,7.7-12.9,8.5-20.4,7.8c-4.7-0.4-6.8-3.7-8.4-7.7c-1.7-4.4-1.4-7.1,0.9-12.2 c-2.4,3.3-3.5,7-2,11.4c1.4,4.1,3.5,8,8.1,9C269.7,312.6,281.3,311.1,284,302.8z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M275.7,299.6c-0.7,2.6-6.4,5-9.8,4c-4.5-1.4-5.5-7.3-2.3-10c-4,2-3,8.5,1.3,10.2 C268.3,305.1,275,303.8,275.7,299.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.1287,
    y1: 288.4436,
    x2: 278.8958,
    y2: 285.7015,
    gradientTransform: "matrix(0.4316 0.9021 -0.9021 0.4316 415.0257 -83.8247)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M282.9,299.5c0.2-2.3-1.1-4.6-2.9-6.1c-1-0.9-3.9-2.7-4.9-1.4c-0.9,1.1,1.3,3,2,4.3 c1.2,2.3,0.5,3.3,0.1,5.5c-0.4,1.9,0.7,3.5,2.7,2.7C281.8,303.6,282.7,301.3,282.9,299.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.7368,
    y1: 306.3952,
    x2: 281.8268,
    y2: 304.9633,
    gradientTransform: "matrix(0.4316 0.9021 -0.9021 0.4316 415.0257 -83.8247)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M266.1,306.3c-1.2-1-2.5-0.5-4.3-2.1c-0.4-0.4-1.8-1.9-2.7-1.6c-0.9,0.3-0.7,1.5-0.6,2.1 c0.4,1.4,1.4,2.9,2.7,3.4c1.1,0.5,3.1,0.7,4.3,0C266.2,307.8,266.8,306.9,266.1,306.3z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M281.2,300.9c0.2-0.3,0.6-1.2,0.4-1.5c-0.2-0.3-0.3,0.3-0.3,0.4c-0.6,1.5-1.3,1.7-1.5,2.1 c-0.1,0.1,0,0.4,0.2,0.3C280.5,302.1,280.9,301.4,281.2,300.9z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M281.6,298.3c0.1-0.3,0.1-0.4-0.1-0.6c-0.1-0.1-0.3-0.1-0.3,0.1c0,0.2,0,0.3,0.1,0.5 C281.3,298.5,281.6,298.5,281.6,298.3z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M259.9,298.2c-0.7-0.2-2.5-1.2-3.6-2.2c-0.3-0.3-0.5-0.1-0.2,0.3c1.1,1.1,3,2.1,3.7,2.2 C260.2,298.5,260.4,298.4,259.9,298.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 269.6908,
    y1: 297.1,
    x2: 274.6277,
    y2: 297.1,
    gradientTransform: "matrix(0.4316 0.9021 -0.9021 0.4316 415.0257 -83.8247)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M265.7,291.7c-0.5-0.5-1.5-2.4-2-3.8c-0.1-0.4-0.4-0.3-0.3,0.1c0.3,1.5,1.5,3.4,2,3.8 C265.7,292.1,266,292.1,265.7,291.7z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M260.1,296.8c-0.2-0.2-0.3-0.3-0.6-0.4c-0.2-0.1-0.3,0-0.1,0.2c0.2,0.2,0.4,0.3,0.6,0.4 C260.2,297.1,260.3,297,260.1,296.8z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M263.6,286.5c1-0.3,2.7-0.2,3.8,0.6c0.2,0.2,0.6,0.1,0.3-0.1c-2-1.5-6.5-1.3-7.3,1.6c-0.1,0.3,0,0.5,0.3,0.2 C261.7,287.9,262.2,286.9,263.6,286.5z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M270.5,290.8c0-0.2,0-0.3-0.1-0.5c-0.1-0.2-0.3-0.2-0.4,0c0,0.2-0.1,0.3,0,0.5 C270.2,291.1,270.5,291.1,270.5,290.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 270.39,
    y1: 295.6861,
    x2: 271.2176,
    y2: 295.6861,
    gradientTransform: "matrix(0.4316 0.9021 -0.9021 0.4316 415.0257 -83.8247)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M265.4,288.3c0-0.2,0-0.3-0.1-0.5c-0.1-0.2-0.3-0.2-0.4,0c0,0.2-0.1,0.3,0,0.5 C265,288.6,265.4,288.6,265.4,288.3z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M272.2,290.8c0.2-0.2,0.3-0.4,0.4-0.7c0.1-0.4-0.1-0.6-0.4-0.1c-0.2,0.2-0.2,0.5-0.2,0.8 C272,290.8,272.2,290.9,272.2,290.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.6678,
    y1: 365.7684,
    x2: 35.5601,
    y2: 365.7684,
    gradientTransform: "matrix(0.9318 0.3631 -0.3631 0.9318 370.0099 -45.6052)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M270.2,308.4c0-0.3-0.1-0.5-0.2-0.8c-0.2-0.3-0.5-0.3-0.4,0.2c0.1,0.3,0.2,0.5,0.3,0.7 C270,308.6,270.2,308.6,270.2,308.4z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M274.3,307.9c-0.4-1-1.3-2.5-1.9-3.3c-0.2-0.2-0.4-0.1-0.2,0.2c0.3,0.6,1.5,2.7,1.8,3.2 C274.3,308.4,274.5,308.4,274.3,307.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.7326,
    y1: 293.114,
    x2: 292.9944,
    y2: 293.114,
    gradientTransform: "matrix(0.4316 0.9021 -0.9021 0.4316 415.0257 -83.8247)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M277.7,306.3c-1-0.5-2.3-1.9-3.1-2.7c-0.2-0.2-0.3,0-0.2,0.2c0.4,0.6,1.6,1.9,2.8,2.7 C277.7,306.8,278.2,306.6,277.7,306.3z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M272.2,307.4c0.1-0.5-0.1-1.3-0.4-1.7c-0.1-0.1-0.3-0.2-0.2,0.2c0.1,0.4,0.4,1,0.5,1.4 C272,307.7,272.2,307.6,272.2,307.4z"
  }))), /*#__PURE__*/React.createElement("g", null, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9,212.8c0,0,0.2,4.1-0.3,5.5c-1.2,3.8-5.5,7.6-12.8,9c-7.6,1.6-11.8-1-14.8-6.2c-3.2-5.4-2.1-11-2.1-11 s6.8,14.6,14,12.2C65,219.9,73.9,212.8,73.9,212.8z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5,213.6c0,0-4.1-5.6-8.2-6.1c-4.6-0.5-5.5,1.7-6.6,4.5c-1,2.8-3.3-4.3-1.7-5.8c1.6-1.5,3.7-3,7-2.7 c3.2,0.3,7.1,1,8.7,3.6C67.4,209.7,66.5,213.6,66.5,213.6z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_26_",
    cx: 58.8132,
    cy: 211.4673,
    r: 16.0533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    style: {
      stopColor: "#000000"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M73.6,211.2c-1-4.1-2.7-6.1-6-9.3c-5-4.8-12-7.4-17.8-2.4c-9.2,7.9-5.5,15.6-2.6,20.3c1.9,3.1,5.1,6,8.9,6 c4.4,0,9.7-1.7,13.2-4.5C72.4,218.8,74.6,215.1,73.6,211.2z M61.1,216.1c-3.5,1.2-6.5,1.7-8.2-2.4c-0.9-2-2-5.2,0.7-7.5 c3-2.6,9.8-0.2,12.2,4C66.4,211.2,66,214.5,61.1,216.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.2519,
    y1: 226.9922,
    x2: 55.2519,
    y2: 209.8155,
    gradientTransform: "matrix(0.862 -0.507 0.507 0.862 -107.3964 56.8842)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M44.9,212c-0.4-1.9,1.4-2.1,3.9-1.8c3.7,0.5,2.7,3.6,4.8,5.9c0.9,1,2.4,1.3,2.8,2.7c0.3,1-0.2,2.6-0.2,4 c0,2.3-2.2,2.2-4.6,0.6C49.1,221.7,46.2,218.4,44.9,212z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.2483,
    y1: 227.3135,
    x2: 74.2483,
    y2: 217.0706,
    gradientTransform: "matrix(0.862 -0.507 0.507 0.862 -107.3964 56.8842)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M65.9,208.8c-0.6-1.2,0-2.2,1.3-2.7c3.2-1.3,4.7,2.1,5,4.9c0.1,1.3,0.5,3.4-0.6,4.3c-1,0.9-2.9-0.2-3.7-0.8 C66.2,213.2,67.4,211.8,65.9,208.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: -36.2814,
    y1: 118.4372,
    x2: -36.2814,
    y2: 108.7692,
    gradientTransform: "matrix(0.2029 -0.9792 0.9792 0.2029 -43.5137 142.8549)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M57.1,203.1c-1.2-0.4-2-1.6-1.4-2.9c1.1-2.4,4.1-2.2,6.4-0.5c1,0.8,2.8,1.9,2.8,3.3c0,1.4-1.9,1.7-2.8,1.5 C60,204.2,58.1,203.4,57.1,203.1z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M52,200c0-0.1,0.1-0.1,0.1-0.1c0.3,0.2,0.4,0.5,0.2,0.8c0,0.1-0.2,0.1-0.2,0C52,200.5,51.9,200.2,52,200z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M51.4,221.7c-0.1,0-0.1,0-0.1-0.1c0-0.3,0.1-0.6,0.4-0.7c0.1,0,0.2,0.1,0.2,0.2 C51.8,221.4,51.6,221.6,51.4,221.7z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M67.7,213.5c0.3,0.1,2.6,0.7,3.5,1c0.3,0.1,0.5,0.3,0.2,0.3c-0.9,0-2.7-0.5-3.7-1.1 C67.5,213.6,67.3,213.4,67.7,213.5z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M66.8,204.3c0.3-0.3,0.5-0.6,0.7-0.7c0.1-0.1,0.3,0,0.2,0.2c-0.1,0.3-0.5,0.6-0.8,0.8 C66.7,204.6,66.6,204.4,66.8,204.3z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M46.5,208.3c0.5,0.1,0.8,0.1,1,0.2c0.2,0,0.2,0.2-0.1,0.3c-0.3,0.1-0.8-0.1-1.1-0.2 C46.1,208.4,46.3,208.3,46.5,208.3z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M53.1,213.9c0.6,1.5,1.6,2,1.9,2.1c2.5,1.6,5.3,0.2,6.6-0.3c0.8-0.4,2.1-1.2,2.9-2c0.9-1,1.3-1.7,1.1-2.7 c-0.2-1.5-1.6-3-2.8-3.9c0.9,0.4,1.6,1.1,2.2,1.8c1,1.1,1.8,2.7,0.1,4.8c-1.9,2.3-4.6,3.4-7.5,3.7c-1.5,0.2-2.9-0.5-3.8-1.5 c-1-1.2-1.5-3.3-1.9-4.8C52.3,211.7,52.6,212.6,53.1,213.9z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M68.8,216.1c0.5,0.4,1.1,1,1.6,1.5c0.5,0.5,0.1,0.6-0.5,0.3c-0.6-0.3-2.2-1.9-2.4-2.3 C67.4,215.3,67.9,215.5,68.8,216.1z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M44.1,212.4c1.2,4,3,8.2,6,10.7c3,2.5,7.1,3,10.8,1.9c3.9-1.1,8.8-3,10.9-6.6c2.1-3.5,1.7-7.8,0.2-11.2 c1.6,3,2.5,5.9,1.4,9.3c-1.7,5.2-8.1,7.8-12.3,9.1c-2.6,0.7-6.8,1.4-10.6-1.4C46.8,221.3,44.7,216.8,44.1,212.4z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M67.1,214.9c0.1,0.1-0.1,0.3-0.2,0.2c-0.1-0.1-0.3-0.1-0.4-0.3C66.4,214.6,66.6,214.5,67.1,214.9z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M50.3,218c-0.6,0.4-1.3,0.7-1.9,1c-0.6,0.3-0.6-0.1-0.1-0.5c0.5-0.4,2.5-1.3,3-1.4 C51.6,216.9,51.3,217.3,50.3,218z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M52.1,216.8c-0.1,0.1-0.2-0.2-0.1-0.3c0.1-0.1,0.2-0.2,0.4-0.2C52.6,216.3,52.6,216.5,52.1,216.8z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M60.1,221.5c0.2,0.6,0.2,1.5,0.3,2.1c0.1,0.6-0.3,0.5-0.5-0.1c-0.2-0.6-0.5-2.8-0.4-3.3 C59.6,219.9,59.8,220.4,60.1,221.5z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M59.5,219.5c0,0.2-0.2,0.2-0.3,0c-0.1-0.1-0.1-0.3-0.1-0.5C59.2,218.9,59.4,218.9,59.5,219.5z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M51.4,203.3c-0.4-0.5-0.8-1.2-1.2-1.8c-0.3-0.6,0.1-0.6,0.5-0.1c0.5,0.4,1.6,2.4,1.7,2.8 C52.6,204.5,52.1,204.2,51.4,203.3z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M52.8,204.8c-0.1-0.1,0.2-0.2,0.3-0.1c0.1,0.1,0.2,0.2,0.2,0.4C53.3,205.3,53.1,205.4,52.8,204.8z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M67.7,211.8c0.4-0.2,0.7-0.3,1.2-0.3c0.4,0,1.8,0.1,2.3,0.4c0.1,0.1,0.3,0.2,0,0.2c-0.6-0.1-1.3-0.1-1.9-0.1 c-0.5,0-1,0-1.5,0C67.5,212,67.6,211.8,67.7,211.8z"
  }))), /*#__PURE__*/React.createElement("g", null, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M124.2,63.4c0,0-0.2,4.1,0.3,5.5c1.2,3.8,5.5,7.6,12.8,9c7.6,1.6,11.8-1,14.8-6.2c3.2-5.4,2.1-11,2.1-11 s-6.8,14.6-14,12.2C133.1,70.5,124.2,63.4,124.2,63.4z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M131.5,64.2c0,0,4.1-5.6,8.2-6.1c4.6-0.5,5.5,1.7,6.6,4.5c1,2.8,3.3-4.3,1.7-5.8c-1.6-1.5-3.7-3-7-2.7 c-3.2,0.3-7.1,1-8.7,3.6C130.7,60.3,131.5,64.2,131.5,64.2z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_30_",
    cx: 461.8609,
    cy: 62.0493,
    r: 16.0533,
    gradientTransform: "matrix(-1 0 0 1 601.14 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    style: {
      stopColor: "#000000"
    }
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M124.5,61.8c1-4.1,2.7-6.1,6-9.3c5-4.8,12-7.4,17.8-2.4c9.2,7.9,5.5,15.6,2.6,20.3c-1.9,3.1-5.1,6-8.9,6 c-4.4,0-9.7-1.7-13.2-4.5C125.7,69.4,123.5,65.7,124.5,61.8z M137,66.6c3.5,1.2,6.5,1.7,8.2-2.4c0.9-2,2-5.2-0.7-7.5 c-3-2.6-9.8-0.2-12.2,4C131.7,61.8,132.1,65,137,66.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.3946,
    y1: 302.532,
    x2: 478.3946,
    y2: 285.3553,
    gradientTransform: "matrix(-0.862 -0.507 -0.507 0.862 708.5364 56.8842)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M153.2,62.6c0.4-1.9-1.4-2.1-3.9-1.8c-3.7,0.5-2.7,3.6-4.8,5.9c-0.9,1-2.4,1.3-2.8,2.7 c-0.3,1,0.2,2.6,0.2,4c0,2.3,2.2,2.2,4.6,0.6C149,72.2,151.9,69,153.2,62.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 497.391,
    y1: 302.8532,
    x2: 497.391,
    y2: 292.6104,
    gradientTransform: "matrix(-0.862 -0.507 -0.507 0.862 708.5364 56.8842)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M132.2,59.4c0.6-1.2,0-2.2-1.3-2.7c-3.2-1.3-4.7,2.1-5,4.9c-0.1,1.3-0.5,3.4,0.6,4.3c1,0.9,2.9-0.2,3.7-0.8 C131.9,63.8,130.7,62.4,132.2,59.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.8068,
    y1: 482.7842,
    x2: 191.8068,
    y2: 473.1163,
    gradientTransform: "matrix(-0.2029 -0.9792 -0.9792 0.2029 644.6536 142.8549)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M141,53.7c1.2-0.4,2-1.6,1.4-2.9c-1.1-2.4-4.1-2.2-6.4-0.5c-1,0.8-2.8,1.9-2.8,3.3c0,1.4,1.9,1.7,2.8,1.5 C138.1,54.8,140,54,141,53.7z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M146.1,50.6c0-0.1-0.1-0.1-0.1-0.1c-0.3,0.2-0.4,0.5-0.2,0.8c0,0.1,0.2,0.1,0.2,0 C146.1,51.1,146.1,50.8,146.1,50.6z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M146.7,72.3c0.1,0,0.1,0,0.1-0.1c0-0.3-0.1-0.6-0.4-0.7c-0.1,0-0.2,0.1-0.2,0.2 C146.3,72,146.5,72.2,146.7,72.3z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M130.4,64.1c-0.3,0.1-2.6,0.7-3.5,1c-0.3,0.1-0.5,0.3-0.2,0.3c0.9,0,2.7-0.5,3.7-1.1 C130.6,64.2,130.8,63.9,130.4,64.1z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M131.3,54.9c-0.3-0.3-0.5-0.6-0.7-0.7c-0.1-0.1-0.3,0-0.2,0.2c0.1,0.3,0.5,0.6,0.8,0.8 C131.4,55.2,131.5,55,131.3,54.9z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M151.6,58.9c-0.5,0.1-0.8,0.1-1,0.2c-0.2,0-0.2,0.2,0.1,0.3c0.3,0.1,0.8-0.1,1.1-0.2 C151.9,59,151.8,58.9,151.6,58.9z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M145,64.4c-0.6,1.5-1.6,2-1.9,2.1c-2.5,1.6-5.3,0.2-6.6-0.3c-0.8-0.4-2.1-1.2-2.9-2c-0.9-1-1.3-1.7-1.1-2.7 c0.2-1.5,1.6-3,2.8-3.9c-0.9,0.4-1.6,1.1-2.2,1.8c-1,1.1-1.8,2.7-0.1,4.8c1.9,2.3,4.6,3.4,7.5,3.7c1.5,0.2,2.9-0.5,3.8-1.5 c1-1.2,1.5-3.3,1.9-4.8C145.8,62.3,145.5,63.2,145,64.4z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M129.3,66.7c-0.5,0.4-1.1,1-1.6,1.5c-0.5,0.5-0.1,0.6,0.5,0.3c0.6-0.3,2.2-1.9,2.4-2.3 C130.7,65.9,130.2,66.1,129.3,66.7z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M154,63c-1.2,4-3,8.2-6,10.7c-3,2.5-7.1,3-10.8,1.9c-3.9-1.1-8.8-3-10.9-6.6c-2.1-3.5-1.7-7.8-0.2-11.2 c-1.6,3-2.5,5.9-1.4,9.3c1.7,5.2,8.1,7.8,12.3,9.1c2.6,0.7,6.8,1.4,10.6-1.4C151.3,71.9,153.4,67.4,154,63z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M131,65.5c-0.1,0.1,0.1,0.3,0.2,0.2c0.1-0.1,0.3-0.1,0.4-0.3C131.6,65.2,131.5,65.1,131,65.5z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M147.8,68.5c0.6,0.4,1.3,0.7,1.9,1c0.6,0.3,0.6-0.1,0.1-0.5c-0.5-0.4-2.5-1.3-3-1.4 C146.5,67.5,146.8,67.9,147.8,68.5z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M146,67.4c0.1,0.1,0.2-0.2,0.1-0.3c-0.1-0.1-0.2-0.2-0.4-0.2C145.5,66.9,145.5,67.1,146,67.4z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M138,72.1c-0.2,0.6-0.2,1.5-0.3,2.1c-0.1,0.6,0.3,0.5,0.5-0.1c0.2-0.6,0.5-2.8,0.4-3.3 C138.5,70.5,138.3,71,138,72.1z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M138.6,70.1c0,0.2,0.2,0.2,0.3,0c0.1-0.1,0.1-0.3,0.1-0.5C138.9,69.5,138.7,69.5,138.6,70.1z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M146.7,53.9c0.4-0.5,0.8-1.2,1.2-1.8c0.3-0.6-0.1-0.6-0.5-0.1c-0.5,0.4-1.6,2.4-1.7,2.8 C145.5,55.1,146,54.8,146.7,53.9z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M145.3,55.4c0.1-0.1-0.2-0.2-0.3-0.1c-0.1,0.1-0.2,0.2-0.2,0.4C144.8,55.9,145,56,145.3,55.4z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M130.4,62.4c-0.4-0.2-0.7-0.3-1.2-0.3c-0.4,0-1.8,0.1-2.3,0.4c-0.1,0.1-0.3,0.2,0,0.2 c0.6-0.1,1.3-0.1,1.9-0.1c0.5,0,1,0,1.5,0C130.6,62.6,130.5,62.4,130.4,62.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_34_",
    cx: 129.8269,
    cy: 157.2392,
    r: 16.3006,
    gradientTransform: "matrix(-1 0 0 1 281.4707 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    style: {
      stopColor: "#000000"
    }
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M140.2,145.5c5.2-4.4,15.2-4,23.3,5.2c6,6.8,4.3,14.4-2.1,18.8c-6.4,4.4-17.6,0.3-22.3-6 C134.2,157.2,135.5,149.5,140.2,145.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 139.7851,
    y1: 162.1837,
    x2: 133.2567,
    y2: 151.0847,
    gradientTransform: "matrix(-1 0 0 1 281.4707 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M139.9,149c0.2-0.3,1.1-1.2,2.1-1.2c1.5,0,2,1.6,2.4,2.8c1.1,2.8,3.2,5,5,7.4c1.1,1.5,2.3,3.4,1.3,5.2 c-2.3,4-8.3-0.2-10.3-2.4C137.4,157.3,137,152.6,139.9,149z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M138.6,153.8c0-0.4,0.2-0.2,0.3,0.2c0.2,1.5,0.5,3,1.3,4.3c0.8,1.4,1.9,2.5,3.2,3.4c0.4,0.2,0.3,0.5-0.1,0.3 C140.6,160.6,138.4,157,138.6,153.8z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M145,162.8c0.4,0.2,0.9,0.3,1.2,0.4c0.3,0.1,0.9,0.3,1.1,0.4c0.4,0.3,0,0.3-0.4,0.3 c-0.9-0.1-1.8-0.6-2.1-0.9C144.5,162.8,144.7,162.6,145,162.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.8398,
    y1: 160.2608,
    x2: 117.8702,
    y2: 150.1118,
    gradientTransform: "matrix(-1 0 0 1 281.4707 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M157.6,146.6c2.8,1.4,6.2,4.8,7.5,7.8c0.8,2,2.3,7.8-0.6,9.3c-2.3,1.2-1.1-3.8-1.1-4.6 c0.2-5-2.5-9.6-6.5-12.4C156,146,157.1,146.3,157.6,146.6z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M163.7,152.9c1.4,1.9,2.2,5.7,2,7.6c0,0.3-0.1,0.3-0.1,0C165.5,158,164.9,155.2,163.7,152.9 C163.6,152.9,163.7,152.9,163.7,152.9z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M165.1,161.8c0.1-0.2,0.2-0.2,0.1,0c-0.1,0.4-0.5,0.9-0.8,1.1c-0.2,0.1-0.2,0-0.1-0.2 C164.5,162.4,165,162.2,165.1,161.8z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M146.9,159.4c0.6,0.3,1.2,0.6,1.7,1c0.4,0.3,0.7,0.6,0.7,1.1c0,0.1-0.1,0.2-0.1,0.2c0,0-0.1,0.1-0.2,0.1 c-0.5,0.2-1.2-0.2-1.6-0.5c-0.5-0.4-0.9-0.9-1-1.5C146.3,159.5,146.6,159.2,146.9,159.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_37_",
    cx: 101.6512,
    cy: 312.5522,
    r: 16.3003,
    gradientTransform: "matrix(0.4035 0.915 -0.915 0.4035 424.8697 97.5429)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    style: {
      stopColor: "#000000"
    }
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M195.2,322.4c1.9-6.5-2.5-15.5-14.1-19.2c-8.6-2.7-14.9,1.9-16.3,9.5c-1.4,7.6,6.8,16.2,14.5,18 C186.9,332.6,193.5,328.3,195.2,322.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 111.6092,
    y1: 317.4966,
    x2: 105.0809,
    y2: 306.3976,
    gradientTransform: "matrix(0.4035 0.915 -0.915 0.4035 424.8697 97.5429)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M192.2,324.1c0.2-0.3,0.7-1.5,0.3-2.4c-0.6-1.4-2.3-1.1-3.5-1.1c-3.1,0.1-5.8-1-8.8-1.6 c-1.8-0.4-4-0.8-5.3,1c-2.7,3.7,3.6,7.5,6.4,8.4C185.5,329.7,190.1,328.2,192.2,324.1z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M188.3,327.2c0.3-0.2,0.1-0.3-0.2-0.2c-1.4,0.4-3,0.7-4.5,0.5c-1.6-0.2-3.1-0.7-4.4-1.5 c-0.4-0.2-0.6,0-0.3,0.2C181.3,328.1,185.5,328.7,188.3,327.2z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M177.4,325c-0.3-0.3-0.6-0.7-0.9-1c-0.2-0.2-0.7-0.7-0.8-0.8c-0.4-0.3-0.3,0.1-0.1,0.5 c0.4,0.7,1.3,1.4,1.7,1.5C177.7,325.4,177.8,325.2,177.4,325z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 175.684,
    y1: 315.5725,
    x2: 169.7145,
    y2: 305.4235,
    gradientTransform: "matrix(0.4035 0.915 -0.915 0.4035 392.5802 24.3253)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M187.2,306.9c-2.4-2-6.9-3.7-10.1-3.7c-2.1,0-8,1-8.2,4.3c-0.1,2.6,3.9-0.5,4.7-0.9c4.5-2.2,9.8-1.6,14,1 C188.4,308.2,187.7,307.3,187.2,306.9z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M179,303.9c-2.3-0.5-6.1,0.2-7.8,1.3c-0.2,0.2-0.3,0.3,0.1,0.1C173.6,304.3,176.4,303.7,179,303.9 C179,304,179,303.9,179,303.9z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M170.3,306.2c0.1-0.1,0.1-0.2-0.1-0.1c-0.3,0.2-0.7,0.8-0.7,1.2c0,0.2,0.1,0.2,0.3,0 C170,307,170,306.5,170.3,306.2z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M179.9,321.9c-0.5-0.4-1-0.8-1.6-1.2c-0.4-0.2-0.9-0.4-1.3-0.2c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.1,0,0.2 c0,0.5,0.7,1,1.1,1.2c0.6,0.3,1.2,0.4,1.8,0.3C180,322.5,180.1,322.1,179.9,321.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_40_",
    cx: 268.8021,
    cy: 176.4528,
    r: 16.3006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    style: {
      stopColor: "#000000"
    }
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M280.2,164.8c-5.2-4.4-15.2-4-23.3,5.2c-6,6.8-4.3,14.4,2.1,18.8c6.4,4.4,17.6,0.3,22.3-6 C286.2,176.4,284.9,168.8,280.2,164.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 278.7603,
    y1: 181.3973,
    x2: 272.232,
    y2: 170.2983
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M280.5,168.2c-0.2-0.3-1.1-1.2-2.1-1.2c-1.5,0-2,1.6-2.4,2.8c-1.1,2.8-3.2,5-5,7.4 c-1.1,1.5-2.3,3.4-1.3,5.2c2.3,4,8.3-0.2,10.3-2.4C283,176.6,283.4,171.8,280.5,168.2z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M281.8,173c0-0.4-0.2-0.2-0.3,0.2c-0.2,1.5-0.5,3-1.3,4.3c-0.8,1.4-1.9,2.5-3.2,3.4 c-0.4,0.2-0.3,0.5,0.1,0.3C279.8,179.8,282.1,176.2,281.8,173z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M275.4,182c-0.4,0.2-0.9,0.3-1.2,0.4c-0.3,0.1-0.9,0.3-1.1,0.4c-0.4,0.3,0,0.3,0.4,0.3 c0.9-0.1,1.8-0.6,2.1-0.9C275.9,182,275.8,181.9,275.4,182z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 262.815,
    y1: 179.4743,
    x2: 256.8455,
    y2: 169.3253
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M262.8,165.8c-2.8,1.4-6.2,4.8-7.5,7.8c-0.8,2-2.3,7.8,0.6,9.3c2.3,1.2,1.1-3.8,1.1-4.6 c-0.2-5,2.5-9.6,6.5-12.4C264.4,165.3,263.4,165.5,262.8,165.8z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M256.7,172.2c-1.4,1.9-2.2,5.7-2,7.6c0,0.3,0.1,0.3,0.1,0C254.9,177.2,255.5,174.4,256.7,172.2 C256.9,172.1,256.8,172.1,256.7,172.2z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M255.3,181c-0.1-0.2-0.2-0.2-0.1,0c0.1,0.4,0.5,0.9,0.8,1.1c0.2,0.1,0.2,0,0.1-0.2 C256,181.6,255.5,181.4,255.3,181z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M273.6,178.6c-0.6,0.3-1.2,0.6-1.7,1c-0.4,0.3-0.7,0.6-0.7,1.1c0,0.1,0.1,0.2,0.1,0.2c0,0,0.1,0.1,0.2,0.1 c0.5,0.2,1.2-0.2,1.6-0.5c0.5-0.4,0.9-0.9,1-1.5C274.2,178.7,273.8,178.4,273.6,178.6z"
  }))), /*#__PURE__*/React.createElement("g", null, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M170.1,219.7c0,0-3.1,3.4-4.2,4c-2.4,1.3-8.9,2.9-12.8,0.3c-3.8-2.5-6.4-6.1-7.5-11.1c-1.7-7.5-0.5-9.9,0.9-12.8 c0.5-1.2,3.3-4,3.3-4s0,11.5,2.8,15.7C155.3,215.9,170.1,219.7,170.1,219.7z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M153.9,203.6c0,0,1.9-1.2,4.4,0c2.5,1.2,5,4.7,5.6,6.3c0.8,2.3,0.3,7.4,0.3,7.4s9.4-6.8,2.1-13.1 C158.9,197.8,155.2,201,153.9,203.6z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_43_",
    cx: 123.8695,
    cy: 208.9426,
    r: 15.7737,
    gradientTransform: "matrix(-1 0 0 1 284.353 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    style: {
      stopColor: "#000000"
    }
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M154,194c6.8-1.6,12.2,4,18.5,11c5.3,5.9-2.1,18.2-11,18.8c-8.9,0.6-12.8-5.3-14.4-13.2 C145.9,204.1,145.9,195.9,154,194z M158.9,215.3c3.5,0.7,9.7-2.8,6.7-7c-2.1-3.1-5.9-7.7-9.1-6.1 C151,204.9,155.4,214.6,158.9,215.3z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M149.3,196.5c-4.6,8.2-2.1,15.3,1.8,21.8c2.4,4,6.3,4.6,10.6,4.3c4.7-0.3,7.1-1.8,10.6-6.1 c-1.9,3.6-4.8,6.2-9.4,6.7c-4.3,0.5-8.8,0.3-11.6-3.4C146.6,213.7,143,202.5,149.3,196.5z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M155.8,202.6c-2,1.8-1.8,7.9,0.7,10.6c3.2,3.4,9,1.8,10-2.2c-0.1,4.5-6.4,6.3-9.7,3.2 C154,211.7,152.3,205.1,155.8,202.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.9793,
    y1: 199.9027,
    x2: 121.7459,
    y2: 197.1605,
    gradientTransform: "matrix(-1 0 0 1 284.353 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M152.8,196.1c2-1.2,4.6-1,6.8,0c1.2,0.6,4.1,2.3,3.4,3.8c-0.6,1.3-3.3,0.1-4.8,0c-2.6-0.2-3.2,1-5,2.3 c-1.5,1.1-3.5,0.9-3.6-1.3C149.5,198.9,151.2,197,152.8,196.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.5866,
    y1: 217.8548,
    x2: 124.6762,
    y2: 216.4228,
    gradientTransform: "matrix(-1 0 0 1 284.353 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M153.8,214.2c1.4,0.6,1.6,2,3.7,2.9c0.5,0.2,2.5,0.8,2.6,1.8c0.1,1-1,1.3-1.7,1.4c-1.4,0.2-3.2-0.1-4.3-0.9 c-0.9-0.7-2-2.5-1.9-3.8C152.4,214.7,153,213.8,153.8,214.2z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M152.2,198.2c0.2-0.3,0.8-1.1,1.2-1c0.4,0.1-0.1,0.4-0.2,0.5c-1.1,1.1-0.9,1.8-1.3,2.3 c-0.1,0.1-0.3,0.1-0.4,0C151.5,199.4,151.9,198.7,152.2,198.2z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M154.4,196.7c0.2-0.2,0.4-0.2,0.6-0.2c0.1,0,0.2,0.2,0,0.3c-0.2,0.1-0.3,0.1-0.5,0.2 C154.4,197.1,154.2,196.8,154.4,196.7z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M163.8,216.3c0.5,0.5,2.2,1.8,3.6,2.3c0.4,0.2,0.3,0.4-0.2,0.3c-1.5-0.5-3.2-1.8-3.6-2.4 C163.4,216.1,163.4,215.9,163.8,216.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.5403,
    y1: 208.5588,
    x2: 117.4774,
    y2: 208.5588,
    gradientTransform: "matrix(-1 0 0 1 284.353 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M167.2,208.3c0.7,0.2,2.8,0.3,4.3,0.1c0.4-0.1,0.5,0.2,0,0.3c-1.5,0.4-3.7,0.1-4.3-0.2 C166.8,208.4,166.7,208.1,167.2,208.3z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M165,215.4c0.2,0.1,0.4,0.2,0.6,0.3c0.2,0.2,0.1,0.3-0.1,0.2c-0.2-0.1-0.4-0.2-0.6-0.4 C164.7,215.5,164.8,215.4,165,215.4z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M172.8,207.9c-0.2-1.1-1-2.5-2.2-3.2c-0.2-0.1-0.3-0.5,0-0.3c2.2,1.2,3.9,5.3,1.7,7.2 c-0.3,0.2-0.5,0.2-0.3-0.2C172.4,210.1,173.1,209.3,172.8,207.9z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M165.9,203.5c0.2-0.1,0.3-0.1,0.5-0.2c0.2,0,0.3,0.2,0.1,0.3c-0.2,0.1-0.3,0.2-0.5,0.2 C165.8,203.9,165.7,203.6,165.9,203.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.2395,
    y1: 207.1447,
    x2: 114.0672,
    y2: 207.1447,
    gradientTransform: "matrix(-1 0 0 1 284.353 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M170.4,207c0.2-0.1,0.3-0.1,0.5-0.2c0.2,0,0.3,0.2,0.1,0.3c-0.2,0.1-0.3,0.2-0.5,0.2 C170.3,207.5,170.2,207.2,170.4,207z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M165.2,201.9c0.1-0.3,0.3-0.5,0.5-0.7c0.3-0.3,0.6-0.1,0.3,0.3c-0.1,0.2-0.3,0.4-0.6,0.5 C165.3,202.1,165.1,202.1,165.2,201.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: -18.8595,
    y1: 193.5711,
    x2: -17.9672,
    y2: 193.5711,
    gradientTransform: "matrix(-0.7297 -0.6838 -0.6838 0.7297 269.6412 57.5996)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M150.2,211.4c0.3-0.1,0.5-0.2,0.8-0.2c0.4,0,0.5,0.3,0,0.4c-0.3,0.1-0.5,0.1-0.8,0 C150.1,211.6,150.1,211.4,150.2,211.4z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M148.8,207.5c1.1,0,2.8,0.1,3.8,0.3c0.3,0,0.2,0.3-0.1,0.3c-0.6,0-3.1-0.2-3.7-0.3 C148.5,207.7,148.4,207.5,148.8,207.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.5828,
    y1: 204.5735,
    x2: 135.8448,
    y2: 204.5735,
    gradientTransform: "matrix(-1 0 0 1 284.353 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1119,
    style: {
      stopColor: "#1C535A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#20646C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6734,
    style: {
      stopColor: "#226F77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23727A"
    }
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M148.9,203.7c0.8,0.7,2.7,1.3,3.7,1.6c0.3,0.1,0.2,0.3-0.1,0.3c-0.7-0.1-2.4-0.6-3.7-1.4 C148.4,203.9,148.4,203.3,148.9,203.7z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M150.2,209.2c0.4-0.3,1.2-0.5,1.7-0.3c0.2,0,0.3,0.2-0.1,0.3c-0.4,0.1-1.1,0-1.5,0.2 C150.1,209.5,150.1,209.2,150.2,209.2z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOlives);
export default __webpack_public_path__ + "static/media/olives.f203da058f6916c43e0455ee9a4e9d67.svg";
export { ForwardRef as ReactComponent };